module.exports = __webpack_public_path__ + "static/img/logo_ES.d45d9e9b.png";